import type { PlaceCategory } from '@shared/types';

const TINT: Partial<Record<PlaceCategory, string>> = {
  beach: '#1d6a8a',
  food: '#8a4b1d',
  grocery: '#2f6b3a',
  medical: '#8a1d2e',
  recreation: '#1d4f8a',
  attraction: '#6b4a1d',
  travel: '#3d3d6b',
  shopping: '#6b3d5a',
  resort: '#0b2a4a',
};

function initials(name: string) {
  const parts = name.replace(/[^A-Za-z0-9 ]/g, '').trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return '·';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
}

export function PlaceAvatar({
  name,
  category,
  imageUrl,
  size = 44,
}: {
  name: string;
  category: PlaceCategory;
  imageUrl?: string;
  size?: number;
}) {
  if (imageUrl) {
    return (
      <img
        className="place-avatar place-avatar--photo"
        src={imageUrl}
        alt=""
        width={size}
        height={size}
        style={{ width: size, height: size }}
      />
    );
  }
  return (
    <span
      className="place-avatar"
      style={{ width: size, height: size, background: TINT[category] ?? 'var(--color-navy)', fontSize: size > 40 ? 14 : 12 }}
      aria-hidden
    >
      {initials(name)}
    </span>
  );
}
